import { ApiBase } from '@/libs/apis/base';

export class ReferencingApiBase extends ApiBase {
  constructor(vue, namespace) {
    super(vue, `referencing${namespace ? `/${namespace}` : ''}`, false);
    this.errorName = 'ReferencingApiError';
  }
}
